import styled, { css } from 'styled-components'

import { Color } from 'constants/color'

import { ReactionWrapperBase } from '../styles'

export const RectangleOuter = styled.div`
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 100%;
    width: 100%;
`
export const RectangleInner = styled.div`
    height: 100%;
    width: 100%;
    z-index: 0;
    border-radius: 10px;
    transition: width 1s, height 1s;
    box-shadow: ${props =>
        props.isActiveSpeaker ? `0px 8px 16px rgba(0, 0, 0, 0.3)` : `none`};
    position: relative;
    ${props =>
        props.fade
            ? css`
                  opacity: 0.1;
              `
            : null}
`

export const TileWrapper = styled.div`
    width: 100%;
    height: 100%;
    position: absolute;
    border-radius: 10px;
    z-index: 5;

    ${props =>
        props.isSpeaking &&
        css`
            border: 3px solid ${Color.unknownColor18};
        `}

    padding: 4px;
    overflow: hidden;

    img {
        background: ${Color.yellow};
        border-radius: 10px;
    }
`

export const NameTag = styled.div`
    border-radius: 20px;
    padding: 3% 5%;
    font-family: Avenir;
    font-style: normal;
    font-weight: 600;
    line-height: 100%;
    color: #ffffff;
    font-size: 0.9vw;
    margin-top: 5px;
    text-align: center;
    overflow: hidden;

    /* handheld devices (ipads, phones, 768px and down) */
    @media only screen and (max-width: 768px) {
        font-size: 1.5vw;
        margin-top: 6px;
    }

    /* handheld devices (ipads, phones, 768px and down) */
    @media only screen and (max-width: 600px) {
        font-size: 1.5vw;
        margin-top: 6px;
    }
    @media only screen and (min-width: 1024px) and (max-width: 1366px) and (-webkit-min-device-pixel-ratio: 2) {
        font-family: AvenirBold;
        letter-spacing: -0.5px;
    }
`
export const Indicators = styled.div`
    display: flex;
    justify-content: space-evenly;
    position: absolute;
    z-index: 10;
    top: 20px;
    left: 20px;
    flex-direction: column;
    width: 5%;
    max-width: 40px;
    min-width: 20px;

    img {
        width: 100%;
        height: unset;
    }
`

export const NameChipContainer = styled.div`
    position: absolute;
    bottom: -5px;
    z-index: 10;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
`

export const ReactionWrapper = styled(ReactionWrapperBase)`
    z-index: 5;
    border-radius: 10px;
`

export const NoteContainer = styled.div`
    position: absolute;
    bottom: 2em;
    left: 2em;
    z-index: 15;
`
